import { Tab, Tabs } from "@mui/material";
import { useEffect } from "react";
import { connect } from "react-redux";
import { ROLES, audit_tabs } from "./constants";
import operations from "./ducks/operations";

const AuditTabs = (props) => {
    const { activeTab, handleChangeTabs, role } = props;

    const { auditorSearch, auditorList } = audit_tabs;
    const { auditor } = ROLES;
    useEffect(() => {
        if (role === auditor) {
            (() => handleChangeTabs)(auditorList);
        }
    }, [role]);
    return (
        <div style={{ display: "flex" }}>
            <Tabs indicatorColor="primary" textColor="primary" value={activeTab} onChange={handleChangeTabs}>
                {role !== auditor && <Tab value={auditorSearch} label="Auditor Search" />}
                <Tab value={auditorList} label="Auditor List" />
            </Tabs>
        </div>
    );
};

const mapStateToProps = (state) => ({
    activeTab: state.auditReducer.activeTab,
    role: state.authReducer.userProfile.role,
});
const mapDispatchToProps = (dispatch) => ({
    handleChangeTabs: (e, tab) => {
        dispatch(operations.handleChangeTabs(tab));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(AuditTabs);
